import React from 'react';
import {
  Box, Typography, Stack, FormControl, Select, MenuItem,
  FormControlLabel, Switch,
} from '@mui/material';

const navy = '#1e3a5f';
const selectSx = { '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e5e7eb' } };

const SwitchRow = ({ label, hint, checked, onChange }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Box>
      <Typography sx={{ fontSize: '0.875rem', color: '#111827', fontWeight: 500 }}>{label}</Typography>
      {hint && <Typography sx={{ fontSize: '0.75rem', color: '#9ca3af', mt: 0.25 }}>{hint}</Typography>}
    </Box>
    <Switch
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      size="small"
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': { color: navy },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: navy },
      }}
    />
  </Stack>
);

/**
 * LeyningSettingsStep
 * שלב הגדרות קריאת תורה והפטרה — משותף ל-ShabbatWidget ו-MoadWidget.
 *
 * Props:
 *   formData  { showLeyning, showHaftarah, leyningDisplayMode }
 *   onChange  (partial) => void
 */
const LeyningSettingsStep = ({ formData, onChange }) => {
  const showLeyning        = formData?.showLeyning        ?? false;
  const showHaftarah       = formData?.showHaftarah       ?? false;
  const leyningDisplayMode = formData?.leyningDisplayMode ?? 'summary';

  return (
    <Box dir="rtl">
      <Typography sx={{ fontWeight: 700, color: navy, fontSize: '1rem', mb: 0.5 }}>
        קריאת תורה והפטרה
      </Typography>
      <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', mb: 2.5, lineHeight: 1.5 }}>
        הצגת פרטי קריאת התורה וההפטרה ברכיב — ספר, פרקים ופסוקים.
      </Typography>

      {/* הצגה */}
      <Box sx={{ bgcolor: 'white', border: '1px solid #e5e7eb', borderRadius: 2, p: 2.5, mb: 2 }}>
        <Typography sx={{ fontWeight: 600, color: '#374151', fontSize: '0.875rem', mb: 1.5 }}>
          מה להציג
        </Typography>
        <Stack spacing={1.5}>
          <SwitchRow
            label="קריאת התורה"
            hint="ספר, פרק ופסוקים של הקריאה"
            checked={showLeyning}
            onChange={(v) => onChange({ showLeyning: v })}
          />
          <SwitchRow
            label="הפטרה"
            hint="מראה מקום ההפטרה — ספר, פרק ופסוקים"
            checked={showHaftarah}
            onChange={(v) => onChange({ showHaftarah: v })}
          />
        </Stack>
      </Box>

      {/* מצב תצוגה */}
      {(showLeyning || showHaftarah) && (
        <Box sx={{ bgcolor: 'white', border: '1px solid #e5e7eb', borderRadius: 2, p: 2.5 }}>
          <Typography sx={{ fontWeight: 600, color: '#374151', fontSize: '0.875rem', mb: 0.5 }}>
            מצב תצוגה
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: '#9ca3af', mb: 1.5 }}>
            תקציר מציג ספר ופרקים בלבד. תצוגה מלאה מפרטת כל עלייה בנפרד.
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              value={leyningDisplayMode}
              onChange={(e) => onChange({ leyningDisplayMode: e.target.value })}
              sx={selectSx}
            >
              <MenuItem value="summary">תקציר — ספר ופרקים</MenuItem>
              <MenuItem value="full">מלא — כל העליות</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default LeyningSettingsStep;
